const keyShortcutExceptionId = "key-shortcut-exception";

export default keyShortcutExceptionId;